<template>
  <v-container>
    <div>
      <h3>
        <u> Rules and Regulations </u>
      </h3>
      In 2024, an agreement was established between NLF and Avinor regulating
      the use of the danger areas. It includes procedures, reporting, electronic
      visibility and requirements for mandatory training for all users. From 1
      May 2025, this agreement also covers flights with hang- and paragliders.
      <br /><br />
      Requirements (short list).
      <ul>
        <li>Minimum SP4/PP4.</li>
        <li>
          Comleted
          <a href="https://www.minidrett.no/kurs/e-66684829" target="_blank"
            >NLF's e-course</a
          >
        </li>
        <li>
          Have knowledge of and memorized relevant airspace and danger area
          boundaries.
        </li>
        <li>Follow local procedures - for some areas this involves PGBox.</li>
        <li>
          Instrument/app showing airspace. The device must be able to issue
          warnings when approaching limits.
        </li>
        <li>Tracklog should be saved for at least 30 days.</li>

        <li>FM Radio on frequency: 154.175 MHz.</li>
        <li>Mobile phone - pilot must be able to answer in the air.</li>
        <li>
          Electronic visebility in
          <a
            href="https://live.safesky.app/map?lat=59.59000&amp;lng=10.00000&amp;zoom=9.00"
            target="_blank"
            >SafeSky Live</a
          >
        </li>
        <li>
          Local rules - may involve additional live tracking in for instance
          PureTrack.
          <v-btn color="primary" small @click="LiveTrackingDialog = true"
            >Read more..</v-btn
          >
        </li>
      </ul>
      <br />

      <!-- <br /><br /> -->

      <a
        href="https://nlf.no/siteassets/hps/dokumenter/luftrom/avtale-nlf---oslo-og-farristma---fareomrader-for-luftsport-oslo-og-farris-tma-15.05.25---signert-polaris-og-nlf.pdf"
        target="_blank"
      >
        Agreement NLF - Polaris ACC. Oslo- and Farris TMA. Dagner Areas.
      </a>
      <br /><br />
      <a
        href="https://hlsk.no/ut-a-fly/apning-av-luftsportbokser/"
        target="_blank"
        >Locale procedures - Hvittingfoss.</a
      >
      <p></p>
    </div>
    <div>
      <h3><u>Danger Areas</u></h3>

      <v-card-actions class="justify-center">
        <v-btn rounded color="primary" @click="getDangerAreas"
          >Get List of Danger Areas
        </v-btn>
        <v-input></v-input>
      </v-card-actions>
      <div>
        <v-toolbar
          dark
          color="blue darken-3"
          class="mb-1"
          v-if="dangerAreas.length > 0"
        >
          <v-text-field
            v-model="search"
            clearable
            solo-inverted
            hide-details
            prepend-inner-icon="mdi-magnify"
            label="Search / Relevant to Box"
          ></v-text-field>
        </v-toolbar>
        <!-- <pre>{{ dangerAreas }}</pre> -->

        <v-data-iterator
          :items="dangerAreas"
          item-key="Area"
          hide-default-footer
          :items-per-page="100"
          :search="search"
        >
          <template v-slot:default="{ items }">
            <v-list>
              <v-list-item
                v-for="item in items"
                :key="item.Area"
                cols="12"
                sm="6"
                md="4"
                lg="3"
                style="border: 1px solid grey"
              >
                <!-- <v-divider></v-divider> -->
                <v-list-item-content style="max-width: 50px">{{
                  item.Area
                }}</v-list-item-content>
                <!-- <v-list-item-content></v-list-item-content> -->
                <v-divider vertical></v-divider>
                <v-list-item-content>{{ item.Name }}</v-list-item-content>
                <v-divider vertical></v-divider>
                <v-list-item-content class="justify-end">{{
                  item.ToFt
                }}</v-list-item-content>
                <!-- <v-divider vertical></v-divider> -->
                <v-list-item-content class="justify-end">{{
                  item.ToM
                }}</v-list-item-content>
              </v-list-item>
            </v-list>
          </template>
        </v-data-iterator>

        <!-- <v-data-iterator
          :items="dangerAreas"
          item-key="Area"
          hide-default-footer
          :items-per-page="100"
          :search="search"
        >
          <template v-slot:default="{ items }">
            <v-row>
              <v-col
                v-for="item in items"
                :key="item.Area"
                cols="12"
                sm="6"
                md="4"
                lg="3"
              >
                <v-divider></v-divider>
                <v-row style="border: 1px solid grey">
                  <v-col>{{ item.Area }}</v-col>
                  <v-col cols="4">{{ item.Name }}</v-col>
                  <v-col>{{ item.ToFt }}</v-col>
                  <v-col>{{ item.ToM }}</v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator> -->

        <!-- <v-data-iterator
          :items="dangerAreas"
          item-key="Area"
          hide-default-footer
          :items-per-page="100"
          :search="search"
        >
          <template v-slot:default="{ items }">
            <v-row>
              <v-col
                v-for="item in items"
                :key="item.Area"
                cols="12"
                sm="6"
                md="4"
                lg="3"
              >
                <v-divider></v-divider>
                <v-row style="border: 1px solid grey">
                  <v-col>{{ item.Area }}</v-col>
                  <v-col cols="4">{{ item.Name }}</v-col>
                  <v-col>{{ item.ToFt }}</v-col>
                  <v-col>{{ item.ToM }}</v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator> -->
      </div>
      <!-- /////////// LIVE TRACKING HELP DIALOG /////////// -->
      <v-dialog
        transition="dialog-bottom-transition"
        max-width="600"
        :value="LiveTrackingDialog"
      >
        <v-toolbar
          ><v-btn small color="primary" @click="LiveTrackingDialog = false"
            ><v-icon>mdi-close</v-icon>Close</v-btn
          ></v-toolbar
        >
        <live-tracking-help></live-tracking-help>
        <!-- </template> -->
      </v-dialog>
      <!-- //////////////////////// -->
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
import LiveTrackingHelp from "@/components/help/LiveTrackingHelp.vue";
export default {
  data() {
    return {
      PureTrackLogo: require("@/assets/puretrack-logo.png"),
      baseUrl: "https://pgapi.azurewebsites.net/dbapi/",
      dangerAreas: [],
      search: "",
      LiveTrackingDialog: false,
      // baseUrl: "http://localhost:3000/dbapi/",
    };
  },
  methods: {
    getDangerAreas() {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      var uri = this.baseUrl + "getDangerAreas/%";
      axios
        .get(uri, axiosConfig)
        .then((response) => {
          this.dangerAreas = response.data;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
  },
  components: {
    LiveTrackingHelp,
  },
};
</script>


